<template>
  <v-form v-model="formValid" ref="formbuilder">
    <v-container fluid class="pa-2 checklist-component">
      <v-app-bar flat dense color="primary" class="darken-2">
        <v-toolbar-title class="subheading">{{
          formProp.id ? $t("checklistapi.form.updateFormProps") : $t("checklistapi.form.addNewForm")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" fab small dark @click="closeDialogHandler">
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-row v-if="loadingFields" class="fill-height mx-0" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          {{ $t("checklistapi.props.preparingFields") }}
        </v-col>
        <v-col cols="6">
          <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            autocomplete="new-password"
            :readonly="readOnly"
            outlined
            hide-details
            :rules="$_requiredValidation"
            :label="$t('checklistapi.common.name')"
            v-model="formProp.name"
            required
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            autocomplete="new-password"
            :readonly="readOnly"
            outlined
            hide-details
            :label="$t('checklisttemplate.description')"
            v-model="formProp.description"
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            autocomplete="new-password"
            :readonly="readOnly"
            :no-data-text="$t('global.no_data_available')"
            :items="$dd_checklisttemplate_checklist_status()"
            v-model="formProp.status"
            item-text="text"
            item-value="key"
            hide-details
            outlined
            :label="$t('checklistapi.checklist.selectStatus')"
            dense
            :rules="$_requiredValidation"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            autocomplete="new-password"
            :readonly="readOnly"
            :no-data-text="$t('global.no_data_available')"
            :items="$dd_checklisttemplate_checklist_type()"
            v-model="formProp.checklist_type"
            item-text="text"
            item-value="key"
            hide-details
            outlined
            :label="$t('checklisttemplate.checklist_type')"
            dense
            :rules="$_requiredValidation"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <label>{{ $t("checklisttemplate.templateHeader") }}</label>
          <vue-editor
            :disabled="readOnly"
            v-model="formProp.template_header"
            id="editor-template_header"
            :editorToolbar="customToolbar"
          ></vue-editor>
          <!-- <v-textarea outlined hide-details  :rules="$_requiredValidation"  v-model="formProp.template_header" :label="$t('checklisttemplate.machine_group')" :placeholder="$t('checklisttemplate.machine_group')" required></v-textarea> -->
        </v-col>
        <!-- <v-col cols="12" md="3">
            <v-autocomplete autocomplete="new-password" :no-data-text="$t('global.no_data_available')" :items="listOfChecklistFormulaType" v-model="formProp.formula_type" item-text="name" item-value="id" hide-details outlined :label="$t('checklisttemplate.formula_type')" dense :rules="$_requiredValidation"></v-autocomplete>
          </v-col> -->
        <v-col cols="12" md="3">
          <v-checkbox
            :readonly="readOnly"
            :label="$t('checklisttemplate.not_affect_status')"
            v-model="formProp.not_affect_status"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="3" v-if="formProp.id">
          <v-btn :disabled="readOnly" outlined color="primary" @click="getPDFContent('head')">{{ $t("checklistapi.form.addHeader") }}</v-btn
          >&nbsp;
          <v-btn :disabled="readOnly" outlined color="success" @click="getPDFContent('foot')">{{
            $t("checklistapi.form.addFooter")
          }}</v-btn>
        </v-col>
        <v-col cols="12" v-if="formProp.id">
          <v-card class="pa-0">
            <v-app-bar flat dense color="secondary">
              <v-toolbar-title class="subheading">{{ $t("checklistapi.form.formProps") }}</v-toolbar-title>
            </v-app-bar>
            <v-divider></v-divider>
            <v-card-text class="pa-1">
              <small
                class="ml-2"
                v-html="`* <code>${$t('checklistapi.checklist.drag')}</code> ${$t('checklistapi.layout.properties')}`"
              ></small>
              <v-form ref="fieldsForm">
                <v-container fluid class="pa-0">
                  <v-row>
                    <v-col cols="5" sm="4" md="3" lg="2">
                      <div
                        id="component-section"
                        :class="componentSectionFixed ? 'component-section-fixed' : ''"
                        :style="componentSectionFixed ? `width: ${componentFixedWidth}px;` : ''"
                        ref="expansionPanelGroup"
                      >
                        <v-progress-linear indeterminate color="primary" v-if="propertiesLoading"></v-progress-linear>
                        <v-expansion-panels focusable :v-model="readOnly ? [] : expandedPanel" :disabled="readOnly">
                          <v-expansion-panel v-for="(type, i) in propertyTypes" :key="i">
                            <v-expansion-panel-header class="pa-1" style="min-height: 34px !important">{{
                              setPanelTitle(type)
                            }}</v-expansion-panel-header>
                            <v-divider></v-divider>
                            <v-expansion-panel-content class="pa-1 content_wrap_custom">
                              <v-list ref="getDropAreaHeight" class="pt-0">
                                <v-list-item-group>
                                  <div v-for="(item, index) in listOfProperties[type]" :key="index" :value="item">
                                    <drag
                                      @dragstart="showHighlighter"
                                      @dragend="hideHighlighter"
                                      class="drag"
                                      :transfer-data="{ data: item }"
                                    >
                                      <template slot="image">
                                        <div class="dragging pa-1">
                                          <span class="pa-0">
                                            <v-icon>mdi-arrange-send-backward</v-icon>
                                            <b class="ml-2">{{ $t("checklistapi.props.dragging") }}</b>
                                          </span>
                                        </div>
                                      </template>
                                      <v-chip label small class="mt-1 hover--class" color="primary" outlined>
                                        <v-icon left color="#00bfff">{{
                                          type === "standard" || type === "advanced" ? item.icon : "mdi-drag"
                                        }}</v-icon>
                                        {{ item.name }}
                                      </v-chip>
                                    </drag>
                                  </div>
                                </v-list-item-group>
                              </v-list>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-col>
                    <v-col
                      ref="testRef"
                      cols="7"
                      sm="8"
                      md="9"
                      lg="10"
                      class="border overflow-auto"
                      style="max-width: 82.333333%; height: fit-content"
                    >
                      <v-card flat>
                        <drop @drop="addNewFieldToForm" :class="`${dragging ? 'drop-highlight' : ''}`">
                          <div
                            class="pa-0"
                            dense
                            v-if="listOfAddedFields && listOfAddedFields.length > 0"
                            :style="{
                              'min-height': `${dropAreaHeight}px`,
                              'min-width': '1080px',
                              overflow: 'hidden',
                              'overflow-y': 'scroll'
                            }"
                          >
                            <draggable v-model="listOfAddedFields" class="row mx-1" id="fieldDroppingArea" :disabled="readOnly">
                              <template v-for="item in listOfAddedFields">
                                <v-col
                                  class="pt-1 pb-1"
                                  v-if="!item.isPanelField"
                                  :cols="
                                    [18, 19, 20, 22, 23, 24, 25].includes(item.type)
                                      ? 12
                                      : $vuetify.breakpoint.width < 568
                                      ? 12
                                      : $vuetify.breakpoint.width < 968
                                      ? 6
                                      : item.columns
                                      ? item.columns
                                      : '12'
                                  "
                                  :md="
                                    item.columns ? item.columns : [10, 11, 12, 14, 19, 20, 22, 23, 24, 25].includes(item.type) ? '12' : '6'
                                  "
                                  :key="item._id"
                                >
                                  <form-fields
                                    :ref="`parentSignature_${item.id}`"
                                    :fields="fields"
                                    :item="item"
                                    :addToPanel="addItemsToPanel"
                                    :parseDate="parseDate"
                                    :edit="editProperties"
                                    :remove="removeFormField"
                                  ></form-fields>
                                </v-col>
                              </template>
                            </draggable>
                          </div>
                          <template v-else>
                            <v-alert
                              color="primary"
                              class="text-center mb-0"
                              outlined
                              dark
                              border="left"
                              prominent
                              :style="{ 'min-height': `${dropAreaHeight}px` }"
                            >
                              <span class="text-center">
                                {{ $t("checklistapi.form.dropFields") }}
                              </span>
                            </v-alert>
                          </template>
                        </drop>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-layout justify-center>
          <v-btn :disabled="readOnly || $hasExtraModule('checklist') != 'active'" color="success" :loading="loading" @click="saveUpdateHandler('SAVE')" dark class="mr-4">{{
            formProp.id ? $t("checklistapi.app.update") : $t("checklistapi.app.save")
          }}</v-btn>
          <v-btn :disabled="readOnly || $hasExtraModule('checklist') != 'active'" color="info" v-if="formProp.id" :loading="loading" @click="saveUpdateHandler('UPDATE_CLOSE')" dark>{{
            $t("checklistapi.app.updateClose")
          }}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-container>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <v-card>
        <form-properties
          :payload="payload"
          :propertyNames="existingPropNames()"
          :propertyGroupedByType="groupedByType"
          v-if="dialog"
          :properties="properties"
          @closeForm="closePropertyDialog"
          @selected="getSelected"
        ></form-properties>
      </v-card>
    </v-dialog>
    <v-dialog v-model="pdfTemplateDialog" persistent max-width="700">
      <v-card>
        <v-form ref="pdfContentForm">
          <v-app-bar flat dense color="secondary" class="ma-0 pa-0">
            <v-toolbar-title class="subheading"
              >{{ $t("checklistapi.form.addHtmlContent") }}
              {{ pdfContent.type === "head" ? $t("checklistapi.form.forHeader") : $t("checklistapi.form.forFooter") }}</v-toolbar-title
            >
          </v-app-bar>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-textarea rows="20" filled :rules="$_requiredValidation" v-model="pdfContent.data"></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="pdfContentLoading" @click="savePDFContent">{{ $t("checklistapi.app.update") }}</v-btn>
            <v-btn color="error" @click=";(pdfTemplateDialog = false), $refs.pdfContentForm.reset()">{{
              $t("checklistapi.app.close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="radioStatusLoading" persistent max-width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please wait
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
/* eslint-disable */
import VueCookie from "vue-cookie"
import { Drop, Drag } from "vue-drag-drop"
import {
  componentStatusList,
  standardFields,
  advancedFields,
  listOfFormTypes,
  checklistModules,
  checklistStatuses,
  checklistTypes,
  checklistFormulaType
} from "@/utils/support_list"
import { checklistApi, orgChecklistAPIToken } from "@/plugins/api_settings"
import { VueEditor } from "vue2-editor"
export default {
  model: {
    prop: "formProp",
    event: "change"
  },
  props: ["formProp", "adminChecklistAPIToken"],
  data() {
    return {
      formValid: false,
      readOnly: false,
      properties: {
        font_size: 1
      },
      loading: false,
      propertiesLoading: false,
      propertyTypes: ["standard", "advanced", "favourite"],
      listOfProperties: {
        // standard: standardFields,
        // advanced: advancedFields,
        standard: [
          {
            type: 1,
            name: this.$t("checklisttemplate.text_field"),
            icon: "mdi-form-textbox"
          },
          {
            type: 2,
            name: this.$t("checklisttemplate.text_area"),
            icon: "mdi-format-align-left"
          },
          {
            type: 3,
            name: this.$t("checklisttemplate.checkbox"),
            icon: "mdi-checkbox-marked-outline"
          },
          {
            type: 4,
            name: "Radio",
            icon: "mdi-radiobox-marked"
          },
          {
            type: 5,
            name: this.$t("global.select"),
            icon: "mdi-playlist-check"
          },
          {
            type: 6,
            name: this.$t("checklisttemplate.date"),
            icon: "mdi-calendar-today"
          },
          {
            type: 7,
            name: this.$t("checklisttemplate.time"),
            icon: "mdi-calendar-clock"
          },
          {
            type: 11,
            name: this.$t("checklisttemplate.divider"),
            icon: "mdi-minus"
          },
          {
            type: 15,
            name: this.$t("checklistapi.checklist.label"),
            icon: "mdi-label-outline"
          },
          {
            type: 16,
            name: "HTML",
            icon: "mdi-language-html5"
          }
        ],
        advanced: [
          {
            type: 10,
            name: this.$t("checklisttemplate.component"),
            icon: "mdi-view-compact",
            isAdvanced: true
          },
          {
            type: 13,
            name: this.$t("checklistapi.form.signature"),
            icon: "mdi-message-draw",
            isAdvanced: true
          },
          {
            type: 14,
            name: this.$t("checklisttemplate.panel"),
            icon: "mdi-view-agenda",
            isAdvanced: true
          },
          {
            type: 19,
            name: "Advanced Survey Component",
            icon: "mdi-view-compact",
            isAdvanced: true
          },
          {
            type: 20,
            name: this.$t("checklisttemplate.checkpoint_123s"),
            icon: "mdi-alpha-c-box-outline",
            isAdvanced: true
          },
          {
            type: 21,
            name: this.$t("checklisttemplate.checkpoint_radio_status"),
            icon: "mdi-alpha-c-box-outline",
            isAdvanced: true
          },
          {
            type: 22,
            name: "Formula1 Checkpoint 123S",
            icon: "mdi-newspaper-variant-outline",
            isAdvanced: true
          },
          {
            type: 23,
            name: "Formula2 Checkpoint 123S",
            icon: "mdi-newspaper-variant-outline",
            isAdvanced: true
          },
          {
            type: 24,
            name: "Formula3 Checkpoint 123S",
            icon: "mdi-newspaper-variant-outline",
            isAdvanced: true
          },
          {
            type: 25,
            name: "Formula4 Checkpoint 123S",
            icon: "mdi-newspaper-variant-outline",
            isAdvanced: true
          }
        ],
        favourite: [],
        custom: []
      },
      loadingFields: false,
      selectedProps: 0,
      listOfAddedFields: [],
      dropAreaHeight: 100,
      dialog: false,
      selectedPropsValues: {},
      statusList: componentStatusList,
      pdfTemplateDialog: false,
      pdfContent: {
        data: "",
        type: ""
      },
      pdfContentLoading: false,
      activePanel: {},
      listOfGroups: [],
      groupsLoading: false,
      dragging: null,
      componentSectionFixed: false,
      componentFixedWidth: 0,
      newFieldColumns: 0,
      listOfFormTypes: listOfFormTypes.sort((a, b) => a.text.localeCompare(b.text)),
      expandedPanel: 0,
      groupedByType: [],
      customProperties: [],
      /* for checkpoint 123ws -new component */
      radioStatusLoading: false,
      CloneOfAddedFields: [],
      formObj: {},
      listOfChecklistModule: checklistModules,
      listOfChecklistStatus: checklistStatuses,
      listOfChecklistType: checklistTypes,
      listOfChecklistFormulaType: checklistFormulaType,

      /* Vue2Editor Toolbar config */
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["blockquote", "code-block"],
        [{ color: [] }],
        ["clean"]
      ],
      gettingFields: false,
      removingFormField: false
    }
  },
  components: {
    Drop,
    Drag,
    draggable: () => import("vuedraggable"),
    FormProperties: () => import("@/mixins/components/checklist/property/Index.vue"),
    FormFields: () => import("./Fields"),
    VueEditor
  },
  created() {
    this.getAllGroups()
    window.addEventListener("scroll", this.handleScroll)
  },
  mounted() {
    if (this.formProp.id) {
      if (this.formProp.mode == "admin") {
        checklistApi.defaults.headers.common["X-AccessToken"] = this.ADMIN_CHECKLIST_API_TOKEN
        this.readOnly = true
      } else {
        let token = null
        let org = VueCookie.get(`__kursweblara_organisation`)

        if (org) {
          org = JSON.parse(org)
          if (org.checklist_api_token) {
            token = org.checklist_api_token
          }
        }
        checklistApi.defaults.headers.common["X-AccessToken"] = token
        //this.readOnly = this.formProp.status == 3 ? true : false
      }
    }

    if (this.formProp.id) {
      this.getSingleRecordHandler()
    } else {
      this.formProp.status = 1
      setTimeout(() => {
        this.addEditorEventListener()
      }, 2000)
    }
    this.$root.$on("updatePropertyList", () => {
      this.getAllPropertiesHandler()
      this.dialog = false
    })
    this.$root.$on("closeDialog", (data) => {
      this.selectedPropsValues = {}
      this.dialog = false
    })
    this.$root.$on("updateProperty", (data) => {
      if (!data.update) {
        if ([20, 22, 23, 24, 25].includes(data.model.type)) {
          let slNo = this.getSlNo()
          data.model.default_value.slNo = slNo
          let subItems = data.model.default_value.subitems
          subItems.forEach((subItem, index) => {
            subItems[index].value = `${slNo}_${index + 1}`
          })
        }
        this.listOfAddedFields.push(data.model)
        data.model._id = undefined
      } else {
        // set slno when new subitems are added
        if ([20, 22, 23, 24, 25].includes(data.model.type)) {
          let slNo = data.model.default_value.slNo
          let subItems = data.model.default_value.subitems
          subItems.forEach((subItem, index) => {
            // if (!subItems[index].value) subItems[index].value = `${slNo}_${index + 1}`
            if (!subItems[index].value) {
              var singleField = this.CloneOfAddedFields.find((x) => x._id === data.model._id)
              let fieldIndex = this.CloneOfAddedFields.indexOf(singleField)
              subItems[index].value = `${slNo}_${this.getSubItemValue(singleField.default_value.subitems)}`
              this.CloneOfAddedFields[fieldIndex].default_value.subitems.push(subItems[index])
            }
          })
        }
        let index = this.listOfAddedFields.findIndex((x) => x._id === data.model._id)
        this.listOfAddedFields[index] = data.model
      }
      let fieldsList = this.$format.cloneVariable(this.listOfAddedFields)
      this.updateFormProperties(this.formProp.form_id, fieldsList, "UPDATE")
      this.getSingleRecordHandler()
      /* quick fix for checkpoint component undefined issue fix - hide dialog only after form properties return from api */
      if ([20, 22, 23, 24, 25].includes(data.model.type)) {
        this.gettingFields = true
        this.$eventBus.$emit("showHideLoader", true)
        // add loader
      } else this.dialog = false
    })
    this.$root.$on("clonePanelEvent", (data) => {
      this.cloneAllTheFields(data)
    })
  },
  methods: {
    showHighlighter() {
      this.dragging = true
      var fieldDropPanel = document.getElementById("fieldDroppingArea")
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        var allFields = []
        children.forEach((child) => {
          allFields.push({ element: child, columns: parseInt(child.classList[0].split("-")[2]) })
        })
        let rowReferenceObj = { previousRows: 0, currentRowOccupiedColumns: 0 }
        allFields.forEach((field, index) => {
          rowReferenceObj.currentRowOccupiedColumns += field.columns
          let tempColumns = rowReferenceObj.currentRowOccupiedColumns
          if (index + 1 !== allFields.length) tempColumns += allFields[index + 1].columns
          if (tempColumns > 12) {
            rowReferenceObj.previousRows += 1
            rowReferenceObj.currentRowOccupiedColumns = 0
          }
        })
        let newElementColumn = 12 - rowReferenceObj.currentRowOccupiedColumns
        newElementColumn = newElementColumn === 0 ? 12 : newElementColumn
        var div = document.createElement("div")
        div.setAttribute("class", `col-md-${newElementColumn}`)
        div.setAttribute("style", "border: 3px dashed #1fb2aa;")
        fieldDropPanel.appendChild(div)
        this.newFieldColumns = newElementColumn
      }
    },
    getSelected(model) {
      this.properties = model
    },
    hideHighlighter() {
      this.dragging = false
      var fieldDropPanel = document.getElementById("fieldDroppingArea")
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        fieldDropPanel.removeChild(children[children.length - 1])
      }
    },
    parseDate(date) {
      return this.$format.formatDate(date, "YYYY-MM-DD", "DD.MM.YYYY")
    },
    saveUpdateHandler(type) {
      if (this.formValid) {
        this.loading = true
        let fieldsList = this.$format.cloneVariable(this.listOfAddedFields)
        let model = this.$format.cloneVariable(this.formProp)
        let formModel = this.$format.cloneVariable(this.formObj)
        formModel.name = model.name
        let method = "post"
        let url = "forms"
        if (model.id) {
          method = "put"
          url = `forms/${model.form_id}`
        } else model.id = undefined
        checklistApi[method](url, formModel)
          .then((response) => {
            model.form_id = response.data._id
            //this.$emit('update', { data: model, status: 'success', type, action: model.id ? 'update' : 'add' })

            model.title = model.name
            model.checklist_template_api_id = model.form_id
            model.machine = model.form_id
            this.$api
              .execute(model.id ? "put" : "post", model.id ? "checklist-template" : "checklist-template", model)
              .then((result) => {
                if (model.id) this.updateFormProperties(model.form_id, fieldsList, type)
                this.$emit("update", { data: response, status: "success", type, action: model.id ? "update" : "add" })
              })
              .catch((error) => {
                this.$handleServerSideError(error)
              })
          })
          .catch((error) => {
            this.$emit("update", { data: error, status: "error", type })
            this.$handleServerSideError(error)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$awn.alert(this.$t("checklistapi.app.validationFailed"))
    },
    updateFormProperties(id, fieldsList, type) {
      fieldsList.forEach((element) => {
        element.form_id = id
        if (element.type === 5 && element.default_value && element.default_value.isAPI) {
          element.default_value.options = []
        }
        element.default_value = element.default_value ? JSON.stringify(element.default_value) : null
        element.validation = element.validation ? element.validation : null
      })
      let itemsJSON = { items: this.$format.cloneVariable(fieldsList) }
      if (this.activePanel._id) {
        this.activePanel = {}
      }
      checklistApi["post"](`formproperties/bulk_save/${id}`, itemsJSON)
        .then((response) => {
          // if (type === 'SAVE' && !id) this.$router.push(`/forms/actions/${id}`)
          // else if (type === 'UPDATE_CLOSE') this.$router.push(`/forms`)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getSingleRecordHandler() {
      checklistApi
        .get(`forms/${this.formProp.form_id}`)
        .then((result) => {
          if (result && result.data) {
            let model = this.$format.cloneVariable(result.data)
            setTimeout(() => {
              this.addEditorEventListener()
            }, 2000)
            // this.formProp = model
          }
        })
        .finally(() => {
          this.getAllPropertiesHandler()
        })
    },
    getFormProperties() {
      let scope = this
      checklistApi
        .get(`formproperties/get_by_form/${this.formProp.form_id}`)
        .then((result) => {
          if (result && result.data) {
            let listOfProps = result.data
            let listOfAllFields = []
            listOfProps.forEach((element, index) => {
              element.default_value = element.default_value ? JSON.parse(element.default_value) : null
              element.validation = element.validation ? element.validation : null
              let getPanelFieldIndex = listOfProps.findIndex((x) => x._id === element.default_value.panelId)
              if (getPanelFieldIndex >= 0) {
                if (!listOfProps[getPanelFieldIndex].panel_fields) listOfProps[getPanelFieldIndex].panel_fields = []
                listOfProps[getPanelFieldIndex].panel_fields.push(element)
              }
              if ([20, 22, 23, 24, 25].includes(element.type)) {
                element.slNo = element.default_value.slNo
              }
            })
            listOfProps.forEach((element, index) => {
              if (element.default_value && element.default_value.panelId) element.isPanelField = true
              element.readonly = scope.readOnly
              listOfAllFields.push(element)
            })
            this.listOfAddedFields = listOfAllFields
            this.CloneOfAddedFields = this.$format.cloneVariable(this.listOfAddedFields)
          }
          this.$root.$emit("hideLoadingForCloneFields")
        })
        .finally(() => {
          this.gettingFields = false
          if (this.removingFormField) {
            this.radioStatusLoading = false
            this.$awn.success(this.$t("global.delete_success", { module: this.$t("checklist.module") }))
            this.removingFormField = false
          }
        })
    },
    getAllPropertiesHandler() {
      this.propertiesLoading = true
      let query = [{ $match: { Is_Active: true } }]
      checklistApi
        .post(`properties/query`, query)
        .then((response) => {
          this.listOfProperties.favourite = response.data.filter((x) => x.favourite)
          let customProperties = response.data.filter((x) => !x.favourite)
          let propertyKeyValues = this.$format.groupBy(customProperties, "type")
          this.listOfProperties = { ...this.listOfProperties, ...propertyKeyValues }
          this.customProperties = customProperties
          this.propertyTypes = [...this.propertyTypes]
        })
        .finally(() => {
          this.setDropAreaHeight()
          this.getFormProperties()
          this.propertiesLoading = false
        })
    },
    addItemsToPanel(item) {
      this.activePanel = item
    },
    addNewFieldToForm(item) {
      if (item) {
        if (item.data.type === 21) {
          this.radioStatusLoading = true
          let data = {
            update: false,
            model: {
              columns: 12,
              font_size: 1,
              is_active: true,
              label: "BRUK ANBEFALT",
              name: "brukanbefalt",
              type: item.data.type,
              default_value: { panelId: 0 }
            }
          }
          setTimeout(() => {
            this.$root.$emit("updateProperty", data)
            this.radioStatusLoading = false
          }, 1000)
        } else {
          let payload = this.$format.cloneVariable(item.data)
          payload.prop_id = payload._id
          payload.id = undefined
          this.selectedPropsValues = payload
          let propid = this.selectedPropsValues.prop_id
          let fieldName = item.data.name
          if (payload.type === 19) {
            fieldName = "S"
            fieldName = `${fieldName}${this.getComponentCount(payload.type)}`
          }
          let newFieldName = this.generateUniqueFieldName(fieldName)
          this.openCreateDialog(newFieldName, propid, this.activePanel._id, item)
        }
      }
    },
    getComponentCount(type) {
      return this.listOfAddedFields.filter((x) => x.type === type).length + 1
    },
    generateUniqueFieldName(fieldName) {
      let numbers = []
      let name = ""
      let value = this.listOfAddedFields.filter((x) => x.name.toString().includes(fieldName))
      if (value.length > 0) {
        value.map(function (val) {
          if (val && val.name.split(/^[^0-9]+/)[1]) {
            numbers.push(val.name.split(/^[^0-9]+/)[1])
          }
          return val
        })
        let getMax = numbers.length > 0 ? Math.max(...numbers) : 0
        let newFieldId = getMax + 1
        name = `${fieldName}${newFieldId}`
      } else {
        name = fieldName
      }
      return name
    },
    cloneAllTheFields(data) {
      if (data) {
        let cloneFields = []
        let { modified_at, form_id, tab_order, name, label, type, validation, default_value, placeholder, is_active, panel_fields } = data
        let fieldName = name
        let newFieldName = this.generateUniqueFieldName(fieldName)
        let panelField = {
          name: newFieldName,
          modified_at,
          form_id,
          tab_order,
          label,
          type,
          validation,
          default_value,
          placeholder,
          is_active
        }
        panelField.default_value = JSON.stringify(panelField.default_value)
        checklistApi.post(`formproperties`, panelField).then((response) => {
          if (response.data) {
            let newAddedPanel = response.data
            panelField._id = newAddedPanel._id
            panelField.default_value = panelField.default_value ? JSON.parse(panelField.default_value) : null
            cloneFields.push(panelField)
            let panelFields = this.$format.cloneVariable(panel_fields)
            if (panelFields && panelFields.length > 0) {
              for (let i = 0; i < panelFields.length; i++) {
                panelFields[i].name = this.generateUniqueFieldName(panelFields[i].name)
                panelFields[i]._id = null
                panelFields[i].default_value = Object.assign({ ...panelFields[i].default_value }, { panelId: newAddedPanel._id })
                cloneFields.push(panelFields[i])
              }
              let mergeWithExistsFields = [...this.listOfAddedFields, ...cloneFields]
              this.updateFormProperties(this.$route.params.form_id, mergeWithExistsFields, "UPDATE")
            }
            this.getSingleRecordHandler()
          }
        })
      }
    },
    removeFormField(item) {
      if (item) {
        this.$awn.confirm(
          this.$t("global.delete_message"),
          () => {
            this.removingFormField = true
            this.radioStatusLoading = true
            checklistApi
              .delete("/formproperties/delete_multiple", { data: { ids: [item._id] } })
              .then((response) => {
                if (response.status == 200) {
                  this.getSingleRecordHandler()
                  // this.$awn.success(this.$t("global.delete_success", { module: this.$t("checklist.module")}));
                }
              })
              .catch((error) => {
                this.removingFormField = false
                this.radioStatusLoading = false
                this.$handleServerSideError(error)
              })
          },
          () => {
            return
          }
        )

        // this.$store.commit('showDeleteDialog', payload)
        this.setDropAreaHeight()
      }
    },
    openCreateDialog(name, propid, panelid, property) {
      this.payload = { from: "forms", savedAlready: false, propid, panelid, name: name, setColumns: this.newFieldColumns }
      if (property && property.data) this.payload.type = property.data.type
      if ([18, 19].includes(property.data.type)) this.payload.setColumns = 12 // this line is to set 12 cols by default when the field is not showing for some components
      if (property && (property.data.isStandard || property.data.isAdvanced)) {
        this.payload.type = property.data.type
        this.payload.isStandard = property.data.isStandard
        this.payload.isAdvanced = property.data.isAdvanced
      }
      this.payload.font_size = 1
      this.properties = this.payload
      this.newFieldColumns = 0
      this.groupedByType = this.customProperties
      this.dialog = true
    },
    editProperties(item) {
      this.payload = { from: "forms", savedAlready: true, propid: item._id, name: item.name }
      if ([20, 22, 23, 24, 25].includes(item.type)) this.payload.slNo = item.slNo
      this.groupedByType = []
      this.dialog = true
    },
    getValuesFromAPI(serachRef, value, index) {
      /*this.$api.execute('get', value.apiUrl, { headers: '' }).then(response => {
        if (value.objectName) this.listOfAddedFields[index].default_value.options = response.data[value.objectName]
        else this.listOfAddedFields[index].default_value.options = response.data
      })*/
    },
    closePropertyDialog() {
      this.dialog = false
    },
    setDropAreaHeight() {
      let box = document.getElementById("component-section")
      setTimeout(() => {
        this.dropAreaHeight = box.clientHeight - 5
      }, 100)
    },
    getPDFContent(type) {
      this.pdfContent.type = type
      checklistApi.get(`forms/${this.formProp.form_id}`).then((response) => {
        if (response.data) {
          this.pdfTemplateDialog = true
          let prop = this.pdfContent.type === "head" ? "pdf_header" : "pdf_footer"
          if (response.data[prop]) this.pdfContent.data = response.data[prop]
        }
      })
    },
    savePDFContent() {
      if (this.$refs.pdfContentForm.validate()) {
        this.pdfContentLoading = true
        let prop = this.pdfContent.type === "head" ? "pdf_header" : "pdf_footer"
        let model = { [prop]: this.pdfContent.data }
        checklistApi
          .put(`forms/${this.formProp.form_id}`, model)
          .then((response) => {
            this.$awn.success(this.$t("checklistapi.app.updateSuccess"))
            this.$refs.pdfContentForm.reset()
          })
          .finally(() => {
            this.pdfTemplateDialog = false
            this.pdfContentLoading = false
          })
      }
    },
    getAllGroups() {
      this.groupsLoading = true
      checklistApi["get"](`groups`)
        .then((response) => {
          this.listOfGroups = response.data
        })
        .finally(() => {
          this.groupsLoading = false
        })
    },
    existingPropNames() {
      let items = this.$format.cloneVariable(this.listOfAddedFields)
      if (this.properties._id) {
        items = items.filter((x) => x._id !== this.properties._id)
      }
      let fieldsNames = items.map((x) => x.name)
      return fieldsNames
    },
    handleScroll() {
      var window_top = window.scrollY
      var componentSection = document.getElementById("component-section")
      var div_top = componentSection.offsetTop * 2
      this.componentFixedWidth = componentSection.clientWidth
      if (window_top > div_top) {
        this.componentSectionFixed = true
      } else {
        this.componentSectionFixed = false
      }
    },
    getTypeName(type) {
      var name = ""
      var typeObj = this.listOfFormTypes.find((x) => x.value === parseInt(type))
      if (typeObj) name = typeObj.text
      return name
    },
    setPanelTitle(type) {
      let title = ""
      switch (type) {
        case "standard":
          title = `${this.$t("checklistapi.layout.standard")} ${this.$t("checklistapi.layout.properties").toLowerCase()}`
          break
        case "favourite":
          title = `${this.$t("checklistapi.checklist.favourite")}`
          break
        case "advanced":
          title = `${this.$t("checklistapi.checklist.advanced")} ${this.$t("checklistapi.layout.properties").toLowerCase()}`
          break
        default:
          break
      }
      return title
    },
    closeDialogHandler() {
      this.$refs.formbuilder.reset()
      this.$emit("closeForm")
    },
    getSlNo() {
      let checkpointComponents = this.listOfAddedFields.filter((x) => [20, 22, 23, 24, 25].includes(x.type))
      var newVal = 0
      if (checkpointComponents && checkpointComponents.length > 0) {
        if (checkpointComponents.length === 1) newVal = checkpointComponents[0].default_value.slNo
        else {
          checkpointComponents.reduce((acc, cmpnt) => {
            newVal = acc = acc > cmpnt.default_value.slNo ? acc : cmpnt.default_value.slNo
          })
        }
      }
      return ++newVal
    },
    getSubItemValue(subItems) {
      // var subItems = this.CloneOfAddedFields.find(x => x._id === fieldId).default_value.subitems
      let values = subItems.filter((x) => x.value).map((x) => parseInt(x.value.split("_")[1]))
      let subItemValueKey = 1
      if (values && values.length > 0) {
        if (values.length === 1) subItemValueKey = values[0]
        else {
          values.reduce((acc, value) => {
            subItemValueKey = acc = acc > value ? acc : value
          })
        }
      }
      return ++subItemValueKey
    },
    addEditorEventListener() {
      const editorEl = document.querySelector("#editor-template_header > .ql-editor")
      if (editorEl) {
        editorEl.addEventListener("keydown", (event) => {
          const maxRows = 5
          var rowsLength = editorEl.childElementCount
          if (rowsLength > 5) editorEl.removeChild(editorEl.childNodes[5])
          if (event.which === 13 && rowsLength > maxRows) {
            this.$awn.warning(this.$t("checklistapi.app.only5rowsAllowed"))
            return false
          }
        })
      }
    }
  },
  watch: {
    expandedPanel(val) {
      setTimeout(() => {
        this.setDropAreaHeight()
      }, 300)
    },
    gettingFields(val) {
      if (!val) {
        this.dialog = false
        this.$eventBus.$emit("showHideLoader", false)
        /* hide loader and dialog */
      }
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteSuccess")
    this.$root.$off("updatePropertyList")
    this.$root.$off("closeDialog")
    this.$root.$off("updateProperty")
    this.$root.$off("clonePanelEvent")
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  }
}
</script>
<style>
.border {
  border: 2px dashed #1976d26b;
}
.dragging {
  width: 160px;
  height: 35px;
  background: #1976d2;
  border: 2px solid lightgray;
  box-shadow: 2px 4px 5px lightgray;
}
.hover--class {
  cursor: move;
}
.drop-highlight {
  transition: background-color 0.5s ease;
  background-color: #d3d3d3;
  border: 1px dashed #8198af;
}
.content_wrap_custom > .v-expansion-panel-content__wrap {
  padding: 0px 2px 2px 2px !important;
}
.component-section-fixed {
  position: fixed;
  top: 70px;
}
.v-card .v-card__title {
  font-weight: unset !important;
}
</style>
